import { VisaoAto } from "./visao-ato.model";

export class VisaoRelacional {
    visaoAto: VisaoAto;
    atoCentral: VisaoRelacionalAtoCentral;
    impactosPoloAtivo: VisaoRelacionalImpacto[];
    impactosPoloPassivo: VisaoRelacionalImpacto[];
    anotacoesPassivasTemDataVigencia: boolean;
	anotacoesAtivasTemDataVigencia: boolean;
}

export class VisaoRelacionalAtoCentral {
    idAto: number;
    epigrafeBase: string;
    dataAtoDMY: string;
    vigencia: Vigencia
    foiRepublicado: boolean;
    ehRepublicador: boolean;
}

export class VisaoRelacionalImpacto {
    idAto: number;
    epigrafeBase: string;
    dataAtoDMY: string;
    dataPublicacaoDMY: string;
    vigencia: Vigencia;
    sigla: string;
    corSimbolo: CorSimbolo;
    hint: string;
    ehRepublicador: boolean;
    dataVigenciaPrimeiraAnotacao: string;
}

export const ATO_NAO_ALTERADO = 1;
export const ATO_JA_ALTERADO = 2;
export const ATO_NAO_VIGENTE = 3;
export const ATO_REVIGORADO = 4;
export const ATO_RETIFICADOR = 5;
export type Vigencia = 1 | 2 | 3 | 4 | 5;
export type CorSimbolo = 1 | 2 | 3 | 4 | 5 | 6;

export const COR_VIGENCIA = [[166, 202, 255], [255, 223, 108], [247, 146, 151], [102, 226, 140], [201, 201, 201]];
export const COR_SIMBOLO = [[0, 95, 236], [249, 197, 44], [215, 36, 64], [52, 189, 89], [126, 126, 126],[163,73,164]];

export const LEGENDAS_VIGENCIAS = [
    { cor: COR_VIGENCIA[0], txt: 'Ato vigente que nunca foi alterado' },
    { cor: COR_VIGENCIA[1], txt: 'Ato vigente que já foi alterado' },
    { cor: COR_VIGENCIA[2], txt: 'Ato não vigente' },
    { cor: COR_VIGENCIA[3], txt: 'Ato revigorado' },
    { cor: COR_VIGENCIA[4], txt: 'Ato que promove retificação' },
];
export const LEGENDAS_SIMBOLOS = [
    { cor: COR_SIMBOLO[0], txt: 'Comando que não altera o texto nem a vigência de outra norma' },
    { cor: COR_SIMBOLO[1], txt: 'Comando que altera o texto ou o período de vigência de outra norma' },
    { cor: COR_SIMBOLO[2], txt: 'Comando que interrompe a vigência de outra norma' },
    { cor: COR_SIMBOLO[3], txt: 'Comando que recupera a vigência de outra norma' },
    { cor: COR_SIMBOLO[4], txt: 'Comando que retifica a norma' },
    { cor: COR_SIMBOLO[5], txt: 'Comando que promove anotação futura (agendada) em outra norma' },
];
